var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.3%",
    y: "-16.7%",
    width: "146.7%",
    height: "146.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.45753369   0 0 0 0 0.474726172   0 0 0 0 0.607959692  0 0 0 0.157615822 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s-20",
    transform: "translate(-605.000000, -217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(515.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(94.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#77C6D5",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FDFDFD",
    fillRule: "evenodd",
    cx: 15,
    cy: 15,
    r: 14.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_icon-camera_211634",
    transform: "translate(7.000000, 9.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.99008,1.9992 L12.34408,1.9992 L10.7604,0.39984 C10.7604,0.39984 10.75256,0.392 10.74864,0.392 L10.7408,0.38416 L10.7408,0.38416 C10.5056,0.14896 10.18808,0 9.82744,0 L6.53464,0 C6.15048,0 5.80944,0.16464 5.57032,0.42728 L5.57032,0.4312 L4.02192,1.9992 L1.31712,1.9992 C0.588,1.9992 0,2.57152 0,3.30064 L0,11.22296 C0,11.95208 0.588,12.544 1.31712,12.544 L14.99008,12.544 C15.71528,12.544 16.3072,11.95208 16.3072,11.22296 L16.3072,3.30064 C16.3072,2.57152 15.71528,1.9992 14.99008,1.9992 Z M8.1536,10.5644 C6.15832,10.5644 4.53152,8.93368 4.53152,6.93448 C4.53152,4.93136 6.15832,3.30456 8.1536,3.30456 C10.1528,3.30456 11.77568,4.93136 11.77568,6.93448 C11.77568,8.93368 10.1528,10.5644 8.1536,10.5644 Z M14.74312,4.0964 C14.44128,4.0964 14.19432,3.84944 14.19432,3.54368 C14.19432,3.23792 14.44128,2.99096 14.74312,2.99096 C15.04496,2.99096 15.29192,3.23792 15.29192,3.54368 C15.29192,3.84944 15.04496,4.0964 14.74312,4.0964 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1536,4.19048 C6.64048,4.19048 5.41744,5.41744 5.41744,6.93448 C5.41744,8.4476 6.64048,9.67848 8.1536,9.67848 C9.6628,9.67848 10.88976,8.45152 10.88976,6.93448 C10.88976,5.41744 9.6628,4.19048 8.1536,4.19048 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.110c57fb8674cb8c671b63530088612f.svg";
export { ForwardRef as ReactComponent };